<template>
  <div class='aspectwrapper'>
    <b-row align-v="center" v-if="item && item.status === 'complete'">
      <b-col class='text-center' v-show="!loading">
        <PlayerParts v-if="src_type === 'parts'" :parts="item.parts" :background="item.background" ref="video" @click.native="play" class='video-object video-placeholder' @playing="playing" @ended="ended" @canplay="can_play" @timeupdate="timeupdate"/>
        <video v-else-if="src_type === 'url'" ref="video" :src="item.fallback_video_url || item.normalised_video_url || item.video_url" @click="play" preload="auto" class='video-object video-placeholder' @playing="playing" @ended="ended" @canplay="can_play" @timeupdate="timeupdate"></video>

        <div id="play_button" class='text-center' v-if="paused" @click="play">
          <b-button @click="play" size="lg" variant="transparent"><img src="@/assets/player_button.png" alt="Play button"  width="32" height="32"/></b-button>
        </div>
      </b-col>
      <b-col v-show="loading">
        <b-container>
          <b-row class="text-center video-placeholder mx-auto" align-v="center">
            <b-col>
              <div class="spinner-border" role="status">
                <span class="sr-only">.</span>
              </div>
            </b-col>
          </b-row>
        </b-container>
      </b-col>
    </b-row>
    <div v-else class='video-player video-placeholder'>
      <b-row align-v="center" class="h-100">
        <b-col class='text-center'>
          <div v-if='item === null'>
            Video not found
          </div>
          <div v-else-if='!item'>
            <div class="spinner-border" role="status">
              <span class="sr-only">.</span>
            </div>
          </div>
          <div v-else-if='item.status === "error"'>
            An error occured <span v-if="debug"><br />{{item.error_message}}</span>
          </div>
          <div v-else-if='item.status === "deleted"'>
            Video deleted
          </div>
          <div v-else-if='item.status === "processing" || item.status === "pending"' class='p-4'>
             Video loading
             <LoadingBar :seconds="estimated_loading_time" :start_date="item.updated" class='mt-2'/>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import PlayerParts from "@/components/PlayerParts.vue"

export default {
  props: ['item', 'replay', 'debug'],
  components: {PlayerParts},
  data() {
    return {
      currentTime: 0,
      paused: true,
      duration: null,
      src_type: null,
      loading: true,
      estimated_loading_time: 30
    }
  },
  watch: {
    'item': {
      deep: true,
      handler: function(after) {
        if (after && after.status !== 'complete') {
          this.paused = true
        }

        if (!this.src_type && after) {
          if (after.fallback_video_url || after.normalised_video_url || after.video_url) {
            this.src_type = 'url'
          } else if (after.parts) {
            this.src_type = 'parts'
          }
        }

        if (after && after.variables && after.variables.length > 0) {
          if (after.variables.length === 1 && after.variables[0].word === 'script') {
            this.estimated_loading_time = after.variables[0].replace_with.length // 1s per character
          } else {
            this.estimated_loading_time = 30 * after.variables.length
          }
        }
      }
    }
  },
  methods: {
    play() {
      if (!this.replay && !this.paused) { // Don't allow replay
        return
      }

      // Reset if html video player
      if (this.item.video_url && !this.$refs.video.paused) {
        this.$refs.video.currentTime = 0
      }

      this.$emit('play')
      this.$refs.video.play()
      this.paused = false
    },
    playing() {
      this.paused = false
      this.$emit('playing')
    },
    ended() {
      this.paused = true
      this.$emit('ended')
    },
    can_play() {
      if (this.$refs.video) {
        this.duration = this.$refs.video.duration
        this.loading = false
        this.$emit('canplay')
      }
    },
    timeupdate() {
      if (this.$refs.video) {
        this.currentTime = this.$refs.video.currentTime
        this.$emit('timeupdate')
      }
    }
  },
}
</script>

<style>

.video-placeholder {
  width: 480px;
  height: 360px;
  background: #EFEFEF;
  margin: auto;
  border-radius: 6px;
}

.video-object {
  margin: auto;
}

#play_button {
  width:100%;
  height:32px;
  position:absolute;
  left:0%;
  right:0%;
  top:0%;
  bottom:0%;
  margin:auto;
}

video {
  border-radius: 6px;
}

.aspectwrapper {
  display: inline-block; /* shrink to fit */
  width: 100%;           /* whatever width you like */
  position: relative;    /* so .content can use position: absolute */
}

.aspectwrapper::after {
  display: block;
  content: '';
}

</style>
